import { Spacer } from '@zillow/constellation';
import { Image, Text } from '@zillow/constellation-10';

import PremiumBadge from '../../../images/premium-badge.png';

import { getActiveProductTypePremiumFeatures } from '../../Freemium/components/FeaturesOfPremium/constants';

import { StyledTextAlignCenter } from '../../StyledComponents/StyledLayout';

const PremiumOverviewModalContent = () => {
  const renderPremiumFeatures = () => {
    return getActiveProductTypePremiumFeatures().map((item, index) => {
      const { heading, modalContent } = item;

      return (
        <Spacer key={index} data-testid="PremiumFeatureItem" marginBottom="md">
          <Text textStyle="body-bold" asChild>
            <p>{heading}</p>
          </Text>
          <Text asChild>
            <p>{modalContent}</p>
          </Text>
        </Spacer>
      );
    });
  };

  return (
    <>
      <StyledTextAlignCenter>
        <Image src={PremiumBadge} alt="premium badge" css={{ width: '130px' }} />

        <Spacer marginBottom="sm" />

        <Text textStyle="heading-sm" asChild>
          <p>Premium gives you more of what you need to successfully manage your business</p>
        </Text>
      </StyledTextAlignCenter>

      <Spacer marginBottom="md" />

      <div data-testid="PremiumFeatureList">{renderPremiumFeatures()}</div>
    </>
  );
};

export default PremiumOverviewModalContent;
